export default {

    /**
     * Get attribute by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getByID: state => (id) => {
        // Return attribute list
        return state.attributes[id];
    },

    /**
     * Get attribute by node id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getByNodeId: state => ({node_id, name}) => {
        const lst = Object.values(state.attributes).filter(el => el.node_id == node_id && el.name == name);
        // Return attribute list
        return lst ? lst[0] : false;
    },

}
